import * as React from 'react';
import PropTypes from 'prop-types';

export default class AutoHeight extends React.Component {

  /** *******************static************************** */
  static propTypes = {
    width: PropTypes.number,
  };

  static defaultProps = {
    width: 1000,
  };

  /** *******************life cycle************************** */
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  render() {
    const { children, width } = this.props;
    const childrenWithProps = React.cloneElement(children,
      {
        scroll: { x: width, y: 1 }  // y的值不重要，css实现自适应
      }
    );
    return (
      <div className="mkui-layout-modal-auto-height" ref={this.ref}>
        {childrenWithProps}
      </div>
    );
  }
}
